import { IReportingEntityWithDeliveryDates, ReportingEntityWithDeliveryDates } from "./ReportingEntity";
import { IProject } from "./Project";
import { IUser } from "./User";
import { IDependencyUpdate } from "./DependencyUpdate";

export interface IDependency extends IReportingEntityWithDeliveryDates {
    ProjectID: number | null;
    ThirdParty: string;
    RagOptionID: number | null;
    LeadUserID: number | null;
    StartDate: Date | null;
    EndDate: Date | null;

    Project?: IProject;
    LeadUser?: IUser;
    DependencyUpdates?: IDependencyUpdate[];
}

export class Dependency extends ReportingEntityWithDeliveryDates implements IDependency {
    public ProjectID = null;
    public ThirdParty = '';
    public RagOptionID = null;
    public LeadUserID = null;
    public StartDate = null;
    public EndDate = null;
    public Contributors = [];
}
